import {
  PriceListDiscountUpdateRequestType,
  PriceListDiscountUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListDiscountUpdate = (priceListDiscountId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceListDiscountUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `price-list-discounts/${priceListDiscountId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as PriceListDiscountUpdateResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTierDiscounts],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.PriceTierDiscounts,
          priceListDiscountId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.VolumeDiscounts],
      });
    },
  });
};
